const ChargePointExpandOptions = {
    OcppConfig: 'ocppConfig',
    AdditionalInfo: 'additionalInfo',
    WifiSignal: 'wifisignal',
    PartnerInfo: 'partnerInfo',
}

export default ChargePointExpandOptions
